/* SPEX premium: proportional ring for AI-generated block images. v2
   CSS container units can't be used safely inside arbitrary generated
   markup, so this measures each product image and exposes --spexRing
   (1.4% of the rendered width, min 2px) for the outline in
   spex-premium.css — same scale as the theme-wide image rings. */
(function () {
  var SEL = '[class*="aigenblock"] img';
  var EXCLUDE =
    '[class*="-hero"],[class*="-banner"],[class*="-slideshow"],' +
    '[class*="-logo"],[class*="-icon"],[class*="-avatar"]';
  if (!('ResizeObserver' in window)) return;

  var seen = new WeakSet();

  function apply(img) {
    var w = img.clientWidth;
    if (!w) return;
    img.style.setProperty(
      '--spexRing',
      Math.max(2, w * 0.014).toFixed(2) + 'px'
    );
  }

  var ro = new ResizeObserver(function (entries) {
    entries.forEach(function (entry) {
      apply(entry.target);
    });
  });

  function scan(root) {
    if (!(root instanceof Element)) return;
    var imgs = root.matches(SEL) ? [root] : root.querySelectorAll(SEL);
    imgs.forEach(function (img) {
      if (seen.has(img) || img.closest(EXCLUDE)) return;
      seen.add(img);
      apply(img); /* size now — RO only tracks later changes */
      ro.observe(img);
    });
  }

  function start() {
    scan(document.body);
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(scan);
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
